// context/ErrorHandlerContext.js
import { createContext, useContext, useState } from 'react';

const ErrorHandlerContext = createContext({
    error: null,
    setError: () => {},
});

export const useErrorHandler = () => useContext(ErrorHandlerContext);

export const ErrorHandlerProvider = ({ children }) => {
    const [error, setError] = useState(null);

    return (
        <ErrorHandlerContext.Provider value={{ error, setError }}>
            {children}
        </ErrorHandlerContext.Provider>
    );
};
